import React from 'react'
import { connect } from 'react-redux'
import Loader from '../../loaders'
import { strings } from '../../../localization/strings'
import { Button, TextField } from '@material-ui/core/index'
import { formatDate } from '../../../utils/dateUtils'
import { getEventInfo } from '../../../utils/tracking'
import {
    VerticalTimeline,
    VerticalTimelineElement,
} from 'react-vertical-timeline-component'
import { getTrackingFormEvents } from '../../../helpers/restHelpers'
import * as queryString from 'query-string/index'
import ReCAPTCHA from 'react-google-recaptcha'
import {
    removeReCaptchaToken,
    setReCaptchaToken,
} from '../../../helpers/dbHelpers'
import Signature from './signature'
import TrackingShare from './trackingShare'

class Component extends React.Component {
    queryStringData = queryString.parse(this.props.location.search)

    state = {
        reCaptchaToken: false,
        loading: false,
        tracking: null,
        code: !this.queryStringData.code ? '' : this.queryStringData.code,
    }

    handleSubmit = () => {
        this.setState({ loading: true })
        getTrackingFormEvents(this.state.code)
            .then((tracking) => this.setState({ tracking: tracking }))
            .catch((error) => {
                this.setState({ tracking: null })
                window.showDialog(error)
            })
            .finally(() => {
                removeReCaptchaToken()
                this.setState({ loading: false, reCaptchaToken: false })
            })
    }

    componentDidMount() {
        removeReCaptchaToken()
    }

    componentWillUnmount() {
        removeReCaptchaToken()
    }

    render() {
        if (this.state.loading) return <Loader />

        const { tracking } = this.state
        const { events } = tracking || {}

        return (
            <div>
                <div className={'centered-element-container'}>
                    <p>{strings.trackingFormDescription}</p>
                </div>

                <div className={'centered-element-container'}>
                    <TextField
                        id="passwordOld"
                        label={strings.trackingFormCode}
                        value={this.state.code}
                        onChange={(e) =>
                            this.setState({ code: e.target.value })
                        }
                    />
                </div>

                <ReCAPTCHA
                    style={{ width: 300, margin: '40px auto' }}
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    onChange={(token) => {
                        setReCaptchaToken(token)
                        this.setState({ reCaptchaToken: true })
                    }}
                />

                <div className={'centered-element-container'}>
                    <Button
                        disabled={
                            !this.state.code || !this.state.reCaptchaToken
                        }
                        onClick={this.handleSubmit}
                        variant="contained"
                        color="primary"
                    >
                        {strings.trackingFormSubmit}
                    </Button>
                </div>

                {!tracking ? null : <Signature tracking={tracking} />}
                {!tracking ? null : (
                    <TrackingShare
                        url={tracking.trackingUrl}
                        trackingNumber={tracking.trackingNumber}
                    />
                )}

                {!events ? null : !events.length ? (
                    <div className={'centered-element-container'}>
                        <h2>{strings.trackingFormResponseEmpty}</h2>
                    </div>
                ) : (
                    <VerticalTimeline layout={'1-column'}>
                        {events.map((event, index) => {
                            const [style, title, message, date] =
                                getEventInfo(event)
                            const warehouse = event.warehouse

                            return (
                                <VerticalTimelineElement
                                    key={index}
                                    className="vertical-timeline-element--work"
                                    date={formatDate(date)}
                                    iconStyle={{
                                        background: style.backgroundColor,
                                        color: '#fff',
                                    }}
                                    icon={style.icon}
                                >
                                    <h3 className="vertical-timeline-element-title">
                                        {title}
                                    </h3>
                                    {warehouse && warehouse.city ? (
                                        <p
                                            style={{ margin: 0 }}
                                            className="vertical-timeline-element-subtitle"
                                        >
                                            {warehouse.city}
                                        </p>
                                    ) : null}
                                    {message ? (
                                        <h4 className="vertical-timeline-element-subtitle">
                                            {message}
                                        </h4>
                                    ) : null}
                                </VerticalTimelineElement>
                            )
                        })}
                    </VerticalTimeline>
                )}
            </div>
        )
    }
}

const mapDispatchToProps = {}
const mapStateToProps = (store) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Component)
